<header class="main-header main-header-overlay" data-sticky-header="true">
    <raksme-secbar [generalLabel]="generalLabels?.data" [siteSettings]="settingsData?.data"></raksme-secbar>
    <raksme-menu [generalLabel]="generalLabels?.data" [siteSettings]="settingsData?.data"></raksme-menu>
</header>